import apiClientCreator from "../../helpers/api/request";
import SocketEndpoints from "../../mixins/system/SocketEndpoints";

import store from "../../store";




export async function loginAttempt({ commit, state }, credentials) {
  try {
    let apiClient = apiClientCreator("auth/login");
    let response = await apiClient.post("", {
      // email: credentials.email,
      password: credentials.username_special,
      username_special: credentials.username_special
    });

    localStorage.setItem("user-token", response.data.token);
    // localStorage.setItem("user-token-login-time", moment());
    commit(
      "user/onAuthSuccess",
      { token: response.data.token },
      { root: true }
    );
  } catch (e) {
    localStorage.removeItem("user-token");
    commit("setBadAttemptToLogIn", true);
    commit("setErrorInfo", "Log-In Failed");
  }
}


export async function getProfile ({ commit, state }) {
  try {
    let apiClient = apiClientCreator("auth/me");
    let response = await apiClient.get();
    commit("user/setProfileData", response.data, { root: true });
    // const data = this.auth.user.id;
    SocketEndpoints.loginMsgSocket.connect();
    //SocketEndpoints.loginMsgSocket.emit("send_id", response.data.id);
  } catch (e) {
     ///localStorage.removeItem("user-token");
  }
}

export function logOut({ commit, state }) {
  return new Promise((resolve, reject) => {
    let apiClient = apiClientCreator("auth/logout");

    apiClient
      .post("", { user_id: store.getters["user/getUserId"] })
      // eslint-disable-next-line no-unused-vars
      .then(response => {
        commit("user/onLogout", null, { root: true });
        localStorage.removeItem("user-token");

        SocketEndpoints.loginMsgSocket.disconnect();
        resolve();
      })
      .catch(err => {
        localStorage.removeItem("user-token");
        reject(err);
      });
  });
}